<template>
  <div>
    <div
      class="assigned-tools-list"
      v-if="assignedTools && assignedTools.length > 0"
    >
      <base-grid
        :items="assignedTools"
        :imageUrls="imageUrls"
        v-on:grid:badge:click="
          $router.push({
            path: $event.url
          })
        "
      />
    </div>
    <div style="text-align: center" v-else>
      You do not have any tools assigned.
    </div>
  </div>
</template>

<script>
import BaseGrid from "@/components/BaseGrid"
import BaseList from "@/components/BaseList"
import titleMixin from "@/mixins/titleMixin"
import User from "@/lib/user"

export default {
  mixins: [titleMixin],
  components: {
    BaseGrid,
    BaseList
  },
  computed: {
    userId() {
      return User.getUserId()
    },
    assignedTools() {
      let tools = this.$store.getters["tools/getAssignedTools"]()
      let returnArray = []
      for (let i in tools) {
        let route = this.$router.options.routes.find(
          el => el.name.toLowerCase() == tools[i].name.toLowerCase()
        )

        let el = {
          name: tools[i].description,
          url: route.path,
          imageUrl: `${tools[i].name}.svg`
        }
        returnArray.push(el)
      }
      return returnArray
    },
    imageUrls() {
      return this.assignedTools.map(el => el.imageUrl)
    }
  },
  data: function() {
    return {
      title: "Tools"
    }
  },
  created() {
    this.$store.dispatch("tools/loadAssignedTools", this.userId)
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
